import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import AcceptanceMatrix from './AcceptanceMatrix';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { formatDateTime } from '../../../utils/formatDateTimes';
import { CorporateTitle } from '../../../helpers/approvalValidatorCommon';

type ApprovalInfoBoxProps = {
  approverUserEmail?: string;
  createdAt?: Date;
  requiredApprovalLevel?: CorporateTitle;
  approvalResults: any;
};

const requiredActionLabels = {
  [CorporateTitle.AccountManager]: 'Asiakkuuspäällikkö',
  [CorporateTitle.SalesManager]: 'Myyntipäällikkö',
  [CorporateTitle.RegionalManager]: 'Aluepäällikkö',
  [CorporateTitle.SalesDirector]: 'Myyntijohtaja',
  [CorporateTitle.CEO]: 'Toimitusjohtaja',
};

export const ApprovalInfoBox = ({
  approverUserEmail,
  createdAt,
  requiredApprovalLevel,
  approvalResults,
}: ApprovalInfoBoxProps) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#e9edf1',
        padding: 4,
        borderRadius: 8,
        minWidth: '600px',
      }}
    >
      <Dialog
        maxWidth={'lg'}
        fullWidth
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Hyväksyntämatriisi</DialogTitle>
        <DialogContent>
          <AcceptanceMatrix approvalResults={approvalResults} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Sulje</Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6" color="primary">
          Hyväksyntäpyynnön tiedot
        </Typography>
      </Box>
      <Table size="small" sx={{ ml: -2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>
              Pyynnön jättänyt
            </TableCell>
            <TableCell>{approverUserEmail ?? '-'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>
              Pyyntö jätetty
            </TableCell>
            <TableCell>
              {createdAt ? formatDateTime(createdAt) : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>
              Vaatii hyväksynnän
            </TableCell>
            <TableCell>
              {requiredApprovalLevel &&
                requiredActionLabels[requiredApprovalLevel]}
              <Button
                startIcon={<OpenInNewIcon />}
                size="small"
                onClick={handleClickOpen}
                sx={{ ml: 1 }}
              >
                Avaa matriisi
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};
